import axios from './configAxios';

export const deleteVehicle = async (id) => {
    return await axios.delete(`vehicles/${Number(id)}/delete/`);
};

